const MODULE_NAME = "PATIENT_MESSAGES";
const SEND_MESSAGE_STARTED = MODULE_NAME + 'SEND_STARTED';
const SEND_MESSAGE_COMPLETED = MODULE_NAME + 'SEND_COMPLETED';
const SEND_BULK_MESSAGE_STARTED = MODULE_NAME + 'SEND_BULK_STARTED';
const SEND_BULK_MESSAGE_COMPLETED = MODULE_NAME + 'SEND_BULK_COMPLETED';
const READ_MESSAGE_COMPLETED = MODULE_NAME + 'READ_COMPLETED';
const CHANGE_AUTOMATIC_READ = MODULE_NAME + 'CHANGE_AUTOMATIC_READ';
const FETCH_CHATS_STARTED = MODULE_NAME + 'CHATS_FETCH_STARTED';
const FETCH_CHATS_COMPLETED = MODULE_NAME + 'CHATS_FETCH_COMPLETED';
const FETCH_CHAT_STARTED = MODULE_NAME + 'CHAT_FETCH_STARTED';
const FETCH_CHAT_COMPLETED = MODULE_NAME + 'CHAT_FETCH_COMPLETED';
const SET_MESSAGE = MODULE_NAME + "SET_MESSAGE";
const SET_MESSAGE_DONE = MODULE_NAME + "SET_MESSAGE_DONE";
const CHAT_FILTER_SYSTEM_LS_KEY = "Chat_FilterSystem";
const CHAT_FILTER_MEASUREMENTS_LS_KEY = "Chat_FilterMeasurements";

export {
  SEND_MESSAGE_STARTED,
  SEND_MESSAGE_COMPLETED,
  SEND_BULK_MESSAGE_STARTED,
  SEND_BULK_MESSAGE_COMPLETED,
  FETCH_CHATS_STARTED,
  FETCH_CHATS_COMPLETED,
  FETCH_CHAT_COMPLETED,
  FETCH_CHAT_STARTED,
  READ_MESSAGE_COMPLETED,
  CHANGE_AUTOMATIC_READ,
  SET_MESSAGE,
  SET_MESSAGE_DONE,
  CHAT_FILTER_SYSTEM_LS_KEY,
  CHAT_FILTER_MEASUREMENTS_LS_KEY
};
